var _dec, _class;
import './cg-bottom-popup.scss';
import { inject } from 'aurelia-framework';
import { FadingFunctionality } from 'resources/extensions/fading_functionality';
import { device__tablet as tablet } from 'resources/constants';
import { EventAggregator } from 'aurelia-event-aggregator';
import { Helper } from 'resources/extensions/helper';
export let CgBottomPopup = (_dec = inject(EventAggregator, Helper), _dec(_class = class CgBottomPopup extends FadingFunctionality {
  constructor(eventAggregator, helper) {
    super();
    this.initHeight = '214';
    this.middleHeight = void 0;
    this.info = void 0;
    this.content = void 0;
    this.maxHeight = 0.9;
    this.setted = false;
    this.avoidFullScroll = false;
    this.simplebarContainer = ['.simplebar-wrapper', '.simplebar-content-wrapper'];
    this.getMostInternalClass = element => {
      const internalElement = element.querySelectorAll('.mdc-tooltip__surface');
      return internalElement?.length ? this.getMostInternalClass(internalElement[internalElement.length - 1]) : element;
    };
    this.onLoop = () => {
      if (this.isDragging) {
        requestAnimationFrame(this.onLoop);
        this.displacement = window.innerHeight - this.axisY + (this.try ? this.diff : 0);
        this.bottomPopup.style.height = `${this.displacement}px`;
        this.eventAggregator.publish('popup-changed', this.bottomPopup.style.height);
        const space = this.info.title ? 120 : 70;
        const shouldFade = this.bottomPopup.clientHeight - this.content.clientHeight < space;
        if (shouldFade) {
          this.fadeBottom.classList.add('fade-bottom');
        }
        setTimeout(() => {
          if (this.parent.popup.clientHeight + 30 < this.popContent.querySelector('.simplebar-content').clientHeight) {
            this.popContent.classList.remove('touching-bottom');
          } else {
            this.popContent.classList.add('touching-bottom');
          }
        }, 200);
      }
    };
    this.getEvent = ev => ev.changedTouches && ev.changedTouches[0] || ev;
    this.eventAggregator = eventAggregator;
    this.helper = helper;
  }
  attached() {
    this.setScrollContainer(this.popContent);
    this.reinstanceScrollbar();
    this.createScrollEvent();
    this.width = window.innerWidth;
    this.handleEventSubscriptions();
  }
  async detached() {
    this.sizeChanged?.dispose();
  }
  handleEventSubscriptions() {
    this.sizeChanged = this.eventAggregator.subscribe('size-changed', payload => {
      this.handleResize();
    });
  }
  bind(bindingContext) {
    this.parent = bindingContext;
  }
  show(forzeInit, props) {
    if (forzeInit === void 0) {
      forzeInit = false;
    }
    this.info = props;
    if (!this.info.content.tooltip) this.info.content = this.getMostInternalClass(this.info.content.root);
    this.getLines();
    this.bottomPopup.style.transform = 'translateY(0)';
    this.setSimplebarContainer(true);
    this.eventAggregator.publish('handle-scroll-interaction', true);
    setTimeout(() => this.onInit(forzeInit), 500);
  }
  hide() {
    if (this.bottomPopup) this.bottomPopup.style.height = '0';
    this.fadeBottom.classList.remove('fade-bottom');
    setTimeout(() => {
      if (this.bottomPopup) this.bottomPopup.style.transform = 'translateY(100%)';
    }, 400);
    this.eventAggregator.publish('popup-changed', 'unset');
    this.eventAggregator.publish('handle-scroll-interaction', false);
    this.popContent.querySelector('#cg-bottom-popup > div.popup-content.au-target > div.simplebar-wrapper > div.simplebar-mask > div > div').scrollTo({
      top: 0
    });
  }
  getLines() {
    const {
      innerHTML,
      innerText
    } = this.info.content.tooltip ? this.info.content.tooltip.querySelector('.mdc-tooltip__surface') : this.info.content;
    const quantityBR = (innerHTML.match(/<br>/g) || []).length + (innerHTML.match(/\|/g) || []).length / 10;
    const characters = this.width < tablet ? 50 : 95;
    this.lines = Math.floor(innerText.trim().length / characters) + quantityBR;
    if (innerText.trim().length <= characters) this.lines = 0;
    const type = this.lines <= 5 ? 'remove' : 'add';
    this.fadeBottom.classList[type]('fade-bottom');
  }
  onTouchStart(ev, avoid) {
    if (avoid === void 0) {
      avoid = false;
    }
    if (ev.cancelable) ev.preventDefault();
    if (avoid) return;
    this.eventAggregator.publish('popup-changed', 'unset');
    this.isDragging = true;
    const e = this.getEvent(ev);
    this.originTouch = e.pageY;
    this.originalHeight = window.innerHeight - this.originTouch;
    this.currentHeight = parseInt(this.bottomPopup.style.height.replace('px', ''));
    if (!this.setted) {
      this.setted = true;
      this.diff = this.currentHeight - this.originalHeight;
    }
    this.onLoop();
  }
  onTouchMove(ev, avoid) {
    if (avoid === void 0) {
      avoid = false;
    }
    this.eventAggregator.publish('handle-scroll-interaction', true);
    if (ev.cancelable) ev.preventDefault();
    if (avoid) return;
    const e = this.getEvent(ev);
    if (this.isDragging) {
      this.try = true;
      this.axisY = e.pageY;
    }
  }
  onTouchEnd(ev, avoid) {
    if (avoid === void 0) {
      avoid = false;
    }
    if (ev.cancelable) ev.preventDefault();
    if (avoid) return;
    this.isDragging = this.setted = this.try = false;
    this.axisY = window.height - 214;
    this.onInit();
  }
  onInit(forzeInit) {
    if (forzeInit === void 0) {
      forzeInit = false;
    }
    let contentHeight = this.popContent.querySelector('.simplebar-placeholder').clientHeight;
    const space = this.info.title ? 140 : 90;
    const content = space + this.content.clientHeight;
    if (forzeInit || content < this.initHeight) {
      this.avoidFullScroll = true;
      if (content < this.initHeight) {
        this.bottomPopup.style.height = `${space + this.content.clientHeight}px`;
      } else {
        const descriptionHeight = this.content.clientHeight === 102 ? this.content.clientHeight + 17 : this.initHeight;
        this.bottomPopup.style.height = `${descriptionHeight}px`;
      }
      this.eventAggregator.publish('popup-changed', this.bottomPopup.style.height);
      if (this.content.clientHeight >= 122) this.fadeBottom.classList.add('fade-bottom');
      return;
    } else if (window.innerHeight * 0.4 < this.displacement) {
      this.bottomPopup.style.height = `${window.innerHeight * this.maxHeight - 20}px`;
      this.popContent.style.maxHeight = `${window.innerHeight * this.maxHeight - 110}px`;
      this.eventAggregator.publish('popup-changed', this.bottomPopup.style.height);
      contentHeight = this.popContent.querySelector('.simplebar-content').clientHeight;
      this.avoidFullScroll = contentHeight + 100 > window.innerHeight * 0.4 && contentHeight + 100 < window.innerHeight * 0.7;
      if (this.displacement > window.innerHeight * 0.4 && this.lines > 5) {
        this.avoidFullScroll = false;
        this.setSimplebarContainer(false);
      }
      if (contentHeight < window.innerHeight * this.maxHeight - 20) {
        this.avoidFullScroll = true;
        this.bottomPopup.style.height = `${contentHeight + 70}px`;
        this.eventAggregator.publish('popup-changed', this.bottomPopup.style.height);
      }
      this.fadeBottom.classList.remove('fade-bottom');
      return;
    } else if (this.displacement < 60) {
      this.parent.hide();
    }
    this.avoidFullScroll = true;
    this.setSimplebarContainer(true);
  }
  handleResize() {
    this.width = window.innerWidth;
    this.maxHeight = this.width < tablet ? 0.9 : 0.75;
  }
  setSimplebarContainer(add) {
    this.simplebarContainer.forEach(x => {
      this.popContent.querySelector(x).classList.toggle('no-scroll', add);
    });
  }
}) || _class);